module.exports = __webpack_public_path__ + "static/media/map-marker-last-current.39590041.svg";